import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function GraduatesHEO () {
  
  const { loader, form, data, report_params } = useSelector(state => state.reports.summGraduatesHEO)
  
  return (
    <RouteLayout title={'Сводная таблица по выпускникам, поступающим в вузы'}>
      <Form form={form}/>
      <Buttons visible={!!data} reportParams={report_params}/>
      {loader
        ? <Spinner />
        : <Table data={data} reportParams={report_params}/>
      }
    </RouteLayout>
  )
}
